/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ebr_Tab_IssuesInputs */

const cs_ebr_tab_issues = /** @type {(inputs: Ebr_Tab_IssuesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upozornění`)
};

const en_ebr_tab_issues = /** @type {(inputs: Ebr_Tab_IssuesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Issues`)
};

/**
* | output |
* | --- |
* | "Issues" |
*
* @param {Ebr_Tab_IssuesInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_tab_issues = /** @type {((inputs?: Ebr_Tab_IssuesInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_Tab_IssuesInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_tab_issues(inputs)
	return cs_ebr_tab_issues(inputs)
});